export default __webpack_public_path__ + "static/media/webdevelopment.7cf275ff.svg";